<template>
    <div class="timeline row q-col-gutter-sm">
        <div class="col-lg-6">
            <timeline-section
                    :client-id="client.id"
                    :date-of-loss="client.dateOfLoss"
            />
        </div>
        <div class="col-lg-6">
            <timeline-section
                    :client-id="client.id"
                    :date-of-loss="client.dateOfLoss"
                    post-date-of-loss
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client } from '@/type';
import TimelineSection from './TimelineSection.vue';

export default defineComponent({
  components: {
    TimelineSection,
  },
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
});
</script>
